import React from 'react';
// Components
import RichTextRenderer from '../richTextRenderer';
import InternalExternalLink from '../Link';

// Interfaces
import { Icon as IconInterface } from '../../interfaces/icon';

function Icon({ body, columnSpan, link, extraClasses }: IconInterface) {
  return (
    <div
      className={`cl-col cl-icon col-span-4 md:col-span-2 ${
        columnSpan ? `lg:col-span-${columnSpan}` : ''
      } ${extraClasses ? extraClasses : ''}`}
    >
      {link ? (
        <InternalExternalLink link={link}>
          <RichTextRenderer text={body} />
        </InternalExternalLink>
      ) : (
        <RichTextRenderer text={body} />
      )}
    </div>
  );
}

export default Icon;
